import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ebd7741"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EoPVerificationReport" }
const _hoisted_2 = {
  key: 0,
  class: "content-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "content-container"
}
const _hoisted_6 = { class: "top-content form-container" }
const _hoisted_7 = { class: "flex-col-centered selection" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Type Selection:")
], -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 1,
  class: "top-content"
}
const _hoisted_11 = { class: "top-container" }
const _hoisted_12 = { class: "eop-v-info" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Summary:", -1))
const _hoisted_14 = { style: {"font-weight":"bold"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "EoP Status:", -1))
const _hoisted_17 = {
  key: 0,
  class: "failure"
}
const _hoisted_18 = {
  key: 1,
  class: "highlight-green-bold"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Journaling Status:", -1))
const _hoisted_21 = {
  key: 0,
  class: "failure"
}
const _hoisted_22 = {
  key: 1,
  class: "highlight-green-bold"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Processed:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Total Amount:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Amount Diff:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Number of Errors:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "View Invoice:", -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "file-list" }
const _hoisted_33 = ["onClick", "disabled", "title"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "invoice-scroll-box" }
const _hoisted_36 = { class: "file-list" }
const _hoisted_37 = ["onClick", "disabled", "title"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-weight":"bold"} }, "Detailed Report:", -1))
const _hoisted_39 = ["disabled", "title"]
const _hoisted_40 = { class: "top-content form-container" }
const _hoisted_41 = { class: "flex-col-centered selection" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Type Selection:")
], -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "new-report-button-div" }
const _hoisted_45 = ["disabled", "title"]
const _hoisted_46 = ["disabled", "title"]
const _hoisted_47 = {
  key: 2,
  class: "table-container"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Previous Reports", -1))
const _hoisted_49 = ["onClick", "disabled", "title"]

import { ref, onMounted, inject, computed } from "vue";
import router from "@/router";
import {
    cols,
    labels,
    EoPVerificationReportServices,
    defaultSortCols,
    defaultSortOrders
} from "@/services/helpers/EoPVerificationReportHelper";
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
// Data
import EoPVerificationReport from "@/models/EoPVerifications/EoPVerificationReport";
// Table
import Table from "@/components/TablePersistentChecking.vue";
// Misc
import { useRoute } from "vue-router";
import log from "loglevel";
import { authService } from "@/auth/authSingleton";
import { apiLoggerKey, globalReloadKey } from "@/types/ServiceKeys";
import { EoPJournalingTypes } from "@/models/EoPVerifications/EoPJournalingTypes";
import MultiplePeriodEoPVerificationReportPopUp from "@/components/MultiplePeriodEoPVerificationReportPopUp.vue"
import NewEoPVerificationReport from "./NewEoPVerificationReport.vue";
import PeriodSelector from "@/components/PeriodSelector.vue";
import DatePeriod from "@/types/DatePeriod";
import { eoPVerificationHeader } from "@/services/network";
import { IEoPItem, IEoPVerifications } from "@/Interfaces/EoPVerifications/IEoPVerifications";
import { parseData } from "@/services/helpers/EoPVerificationsHelper";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

const fileName = "EoPVerification.vue";
const company = "Volvo";

export default /*#__PURE__*/_defineComponent({
  __name: 'EoPVerificationReport',
  setup(__props) {

const reload = inject(globalReloadKey);
const JournalTypesWithNewReportUi: string[] = [EoPJournalingTypes.SERVICE_INVOICE, EoPJournalingTypes.CHURN, EoPJournalingTypes.RECHARGE_INVOICE, EoPJournalingTypes.REMARKETING, EoPJournalingTypes.CAR_PURCHASE, EoPJournalingTypes.RVGF, EoPJournalingTypes.CUSTOMER_INVOICE];

const Logger = inject(apiLoggerKey);

const page = ref(1);

const hasInvoice = ref(false);
const hasMultipleInvoices = ref(false);
const showNewFormatReport = ref(false);
const showMultiplePeriodReportPopUp = ref(false)
const EoPVerifications = ref<IEoPVerifications>();
const displayedEoPVerificationsList = ref<IEoPItem[]>();
log.debug("End of Period Verification Report");

////////////////////////////////////////////////////////////////////////////
// LOGIC
////////////////////////////////////////////////////////////////////////////
onMounted(async () => {
    log.trace("onMounted() EoPVerificationReport");
    document.title = `EoP Verification (${journalType}) - UV`;
    let selectedJournalReportType = route.params.id;
    await GetEoPVerificationReportOptions(market ?? 'GB', period.value)
    if(JournalTypesWithNewReportUi.includes(selectedJournalReportType as string)){
        isLoading.value = false;
        showNewFormatReport.value = true;
    }else{
        //@ts-expect-error
        await GetEoPVerificationReport(journalType.value,market,period.value,company);//.then(() => {});
    }
});

// Get EoP Verification Report Data from API
async function GetEoPVerificationReport(journalType: string, market: string, period: string, company: string) {
    const name = GetEoPVerificationReport.name;
    const Class = fileName + "/" + name;

    const urlParams: string = url + `/${journalType}?market=${market}&period=${period}&company=${company}`;
    
    let Message = `Getting EoP Verification report (${urlParams})`;
    log.trace(`${name}()\n${Message}`);
    try {
        isLoading.value = true;
        hasInvoice.value = false;
        const data = await EoPVRServices.processEoPVerificationData(urlParams);
        eoPVerificationReports.value = data.map(x=>new EoPVerificationReport(x));
        currentEoPVerificationReport.value = eoPVerificationReports.value[0];
        pastEoPVerificationReports.value = eoPVerificationReports.value.slice(1);
        if (!!currentEoPVerificationReport.value) {
            if (!!currentEoPVerificationReport.value.InvoicesInspected){
            hasInvoice.value = true;
            hasMultipleInvoices.value = (currentEoPVerificationReport.value.InvoicesInspected!.length > 1);
            }
        }
        Logger?.LogInformation(Message, Class);
    } catch (error) {
        useNotifierWithErrFormatter().error({error, errorType: "Getting EoP Verification Report"})
        gettingEoPVerificationReportError.value = true;
        infoError.value = true;
        Message = `(Error) ${Message}: ${error}`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}

async function GetEoPVerificationReportOptions(market: string, period: string) {
    const name = GetEoPVerificationReportOptions.name;
    const Class = fileName + "/" + name;
    
    const periodValue = periodSelection.value;
    var Message = `Getting EoPVerifications (market: ${market}, period: ${period})`;
    log.debug("Loading EoPVerification Reports from API");
    isLoading.value = true;
    if (!periodValue.isValid()) console.trace('API periodSelection should not be invalid');
    try {
        const data = (await eoPVerificationHeader.get({market: market.toString(), period: periodValue})).data;
        EoPVerifications.value = data;
        displayedEoPVerificationsList.value = parseData(data);
        displayedEoPVerificationsList.value?.sort((a,b) => {return a.Category.localeCompare(b.Category)})
        Logger?.LogInformation(Message, Class);
    } catch (error) {
        useNotifierWithErrFormatter().error({error, errorType: "Getting EoP Verification Report Options"})
        infoError.value = true;
        Message = `(Error) ${Message}, error: ${error}`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}

// ERROR
const gettingEoPVerificationReportError = ref(false);
const infoError = ref(false);

// TABLE
const isLoading = ref(true);
const url: string = process.env.VUE_APP_EOP_VERIFICATIONS_URL_PARAMS!; 
const eoPVerificationReports = ref<EoPVerificationReport[]>();
const currentEoPVerificationReport = ref<EoPVerificationReport>();
const pastEoPVerificationReports = ref<EoPVerificationReport[]>();

// MISC
const EoPVRServices = new EoPVerificationReportServices();
const buttonStatus = ref(false);

// Send POST request to create new EoP Verification Report
async function CreateNewReport() {
    const name = CreateNewReport.name;
    const Class = fileName + "/" + name;

    log.trace(`${name}()\njournalType: ${journalType}`);
    log.debug("Removing EoPVerifications from sessionStorage");
    sessionStorage.removeItem("EoPVerifications");

    // Disable button until 201 status response
    buttonStatus.value = true;
    isLoading.value = true;

    // Get MARKET and PERIOD from EoP Verifications
    EoPVRServices.LogCreateNewReport(
        market,
        company,
        period.value,
        journalType.value ? journalType.value : "",
    );
    // Send POST request
    try {
        const status = await EoPVRServices.CreateNewEoPReport({
            UserName: authService.getEmailAddress(),
            Market: market ? market : "",
            Company: company,
            StartPeriodMonth: period.value,
            JournalType: journalType.value ? journalType.value : "",
        });
        if (status === 201) {
            log.debug(`CreateNewReport()\nstatus: ${status}`);

            // refresh page
            reload?.();

            // enable button
            buttonStatus.value = false;
            isLoading.value = false;
        }
    } catch (error ){
        useNotifierWithErrFormatter().error({error, errorType: "Creating new EoP verification report"})
        // enable button
        buttonStatus.value = false;
        const Message = `(Error) Creating new EoP Verifications report: ${error}`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}
async function CreateNewMultiplePeriodReport(startPeriod : DatePeriod, endPeriod : DatePeriod) {
    const name = CreateNewReport.name;
    const Class = fileName + "/" + name;

    log.trace(`${name}()\njournalType: ${journalType}`);
    log.debug("Removing EoPVerifications from sessionStorage");
    sessionStorage.removeItem("EoPVerifications");

    // Disable button until 201 status response
    buttonStatus.value = true;
    isLoading.value = true;

    // Get MARKET and PERIOD from EoP Verifications
    EoPVRServices.LogCreateNewMultiplePeriodReport(
        market,
        company,
        startPeriod.toString(),
        endPeriod.toString(),
        journalType.value ? journalType.value :  "",
    );
    // Send POST request
    try {
        const status = await EoPVRServices.CreateNewEoPReport({
            UserName: authService.getEmailAddress(),
            Market: market ? market.toString() : "",
            Company: company,
            StartPeriodMonth: startPeriod.toString(),
            EndPeriodMonth: endPeriod.toString(),
            JournalType: journalType.value!,
        });
        if (status === 201) {
            log.debug(`CreateNewMultiplePeriodReport()\nstatus: ${status}`);
            useNotifierWithErrFormatter().success({msg: "New Multiple Period EoP Verification Report has been created"})
            // refresh page
            reload?.();
        }
    } catch (error ){
        useNotifierWithErrFormatter().error({error, errorType: "Creating new EoP verification report"})
        const Message = `(Error) Creating new multiple period EoP Verifications report: ${error}`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        buttonStatus.value = false;
        isLoading.value = false;
    }
}
const invoicePdfButtonStatus = ref(false);
const detailedReportPdfButtonStatus = ref(false);
const detailedReportPdfButtonStatuses = ref<Record<string,boolean>>({});

// View full page pdf in new tab 
function viewFullPagePDFInvoice(fileID: string | undefined, fileType: string | undefined,) {
    log.trace("viewFullPagePDFInvoice()");
    log.debug(`"viewFullPagePDFInvoice()": ${fileID}`);

    const rResolved = router.resolve({
        name: "EoP Verification (PDF)",
        params: {
            id: fileID,
        },
        query: {
            type: fileType,
            endpoint: process.env.VUE_APP_JOURNALED_INVOICES_DOWNLOAD_URL_PARAMS,
            method: "post"
        },
    });
    const url = rResolved.href;
    // Open in new tab
    window.open(url, "_blank");
}
function viewFullPagePDFReport(fileID: string | undefined, fileType: string | undefined,) {
    log.trace("viewFullPagePDFReport()");
    log.debug(`"viewFullPagePDFReport()": ${fileID}`);

    const rResolved = router.resolve({
        name: "EoP Verification (PDF)",
        params: {
            id: fileID,
        },
        query: {
            type: fileType,
            endpoint: process.env.VUE_APP_DETAILED_REPORT_PDF_EOP_VERIFICATIONS_URL_PARAMS,
            method: "get"
        },
    });
    const url = rResolved.href;
    // Open in new tab
    window.open(url, "_blank");
}

// ROUTE
const route = useRoute();
const journalType = computed( () => {return route.path.split("/").pop()});
const market = route.query.market?.toString();
const period = computed( () => {return route.query.period?.toString() ?? ""});
const displayType = computed( () => {return route.query.type?.toString() ?? ""});
const periodSelection =  ref(new DatePeriod(period ? new Date(period.value) : new Date().addMonths(-1)));
const displayTypeSelection = ref(route.query.type?.toString());
const newEoPKeyValue = ref(0);

function formatAmount(amount: string) {

    const number = parseFloat(amount);

    if (isNaN(number)) {
        return 0.00.toFixed(2);
    }

    const formattedNumber = number.toFixed(2);

    return formattedNumber;
}
async function updatePeriodSelection() {
     log.trace("ViewEoPVerificationReport()\nId:", displayType.value);
    const r = {
        name: "EoP Verification Report",
        params: {
            id: journalType.value,
        },
        query: {
            market: market,
            period: periodSelection.value.toString(),
            type: displayType.value
        },
    };
    await router.replace(r);
    document.title = `EoP Verification (${displayType.value}) - UV`;
    let selectedJournalReportType = displayType.value;
    if(JournalTypesWithNewReportUi.includes(selectedJournalReportType as string)){
        isLoading.value = false;
        newEoPKeyValue.value++;
        showNewFormatReport.value = true;
    }else{
        GetEoPVerificationReport(displayType.value ,market ? market : "",period.value,company);
    }
}
async function updateTypeSelection() {
    log.trace("ViewEoPVerificationReport()\nId:", displayTypeSelection.value);
    const r = {
        name: "EoP Verification Report",
        params: {
            id: displayTypeSelection.value ,
        },
        query: {
            market: market,
            period: period.value,
            type: displayTypeSelection.value
        },
    };
    await router.replace(r);
    document.title = `EoP Verification (${displayTypeSelection.value}) - UV`;
    let selectedJournalReportType = displayTypeSelection.value;
    if(JournalTypesWithNewReportUi.includes(selectedJournalReportType as string)){
        isLoading.value = false;
        newEoPKeyValue.value++
        showNewFormatReport.value = true;
    }else{
        showNewFormatReport.value = false;
        GetEoPVerificationReport(displayTypeSelection.value ? displayTypeSelection.value : "", market ? market : "", period.value, company);
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (showNewFormatReport.value)
            ? (_openBlock(), _createBlock(NewEoPVerificationReport, {
                displayedEoPVerificationsList: displayedEoPVerificationsList.value,
                key: newEoPKeyValue.value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(PeriodSelector, {
                      modelValue: periodSelection.value,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((periodSelection).value = $event)),
                        updatePeriodSelection
                      ],
                      showTitle: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((displayTypeSelection).value = $event)),
                          updateTypeSelection
                        ]
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedEoPVerificationsList.value, (reportType) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: reportType.EoPType
                          }, _toDisplayString(reportType.EoPName), 9, _hoisted_9))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, displayTypeSelection.value]
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["displayedEoPVerificationsList"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_13,
                        _createElementVNode("td", _hoisted_14, _toDisplayString(displayType.value), 1),
                        _hoisted_15
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_16,
                        _createElementVNode("td", null, [
                          (
                                        currentEoPVerificationReport.value?.EoPStatus.toUpperCase().startsWith(
                                                'ERROR'
                                            )
                                        )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(currentEoPVerificationReport.value?.EoPStatus) + " - DEVIATIONS DETECTED ", 1))
                            : (currentEoPVerificationReport.value?.EoPStatus.toUpperCase() == 'SUCCESS')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(currentEoPVerificationReport.value?.EoPStatus), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(currentEoPVerificationReport.value?.EoPStatus), 1))
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_20,
                        _createElementVNode("td", null, [
                          (currentEoPVerificationReport.value?.JournalingStatus.toUpperCase() == 'INCOMPLETE')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(currentEoPVerificationReport.value?.JournalingStatus), 1))
                            : (currentEoPVerificationReport.value?.JournalingStatus.toUpperCase() == 'COMPLETE')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(currentEoPVerificationReport.value?.JournalingStatus), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(currentEoPVerificationReport.value?.JournalingStatus), 1))
                        ])
                      ]),
                      _hoisted_24,
                      _createElementVNode("tr", null, [
                        _hoisted_25,
                        _createElementVNode("td", null, _toDisplayString(currentEoPVerificationReport.value?.ProcessedDateTime), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_26,
                        _createElementVNode("td", null, _toDisplayString(formatAmount(currentEoPVerificationReport.value?.TotalAmount!)), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_27,
                        _createElementVNode("td", null, _toDisplayString(formatAmount(currentEoPVerificationReport.value?.DeviationAmount!)), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_28,
                        _createElementVNode("td", null, _toDisplayString(currentEoPVerificationReport.value?.NumberOfErrorItems), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_29,
                        _createElementVNode("td", null, [
                          (hasInvoice.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (currentEoPVerificationReport.value!.InvoicesInspected!.length <= 5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentEoPVerificationReport.value?.InvoicesInspected, (file) => {
                                        return (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                          _createElementVNode("button", {
                                            onClick: ($event: any) => (viewFullPagePDFInvoice(file,journalType.value!)),
                                            disabled: invoicePdfButtonStatus.value,
                                            title: 
                                                        invoicePdfButtonStatus.value
                                                            ? ''
                                                            : 'View report pdf (opens file in new tab)'
                                                    ,
                                            class: "fake-link"
                                          }, _toDisplayString(file), 9, _hoisted_33)
                                        ]))
                                      }), 256))
                                    ]))
                                  : _createCommentVNode("", true),
                                (currentEoPVerificationReport.value!.InvoicesInspected!.length > 5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentEoPVerificationReport.value?.InvoicesInspected, (file) => {
                                          return (_openBlock(), _createElementBlock("li", _hoisted_36, [
                                            _createElementVNode("button", {
                                              onClick: ($event: any) => (viewFullPagePDFInvoice(file,journalType.value!)),
                                              disabled: invoicePdfButtonStatus.value,
                                              title: 
                                                        invoicePdfButtonStatus.value
                                                            ? ''
                                                            : 'View report pdf (opens file in new tab)'
                                                    ,
                                              class: "fake-link"
                                            }, _toDisplayString(file), 9, _hoisted_37)
                                          ]))
                                        }), 256))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_38,
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (viewFullPagePDFReport(currentEoPVerificationReport.value?.ReportName!,'EndOfPeriodVerification'))),
                            disabled: detailedReportPdfButtonStatus.value,
                            title: 
                                            invoicePdfButtonStatus.value
                                                ? ''
                                                : 'View report pdf (opens file in new tab)'
                                        ,
                            class: "fake-link"
                          }, _toDisplayString(currentEoPVerificationReport.value?.ReportName), 9, _hoisted_39)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(PeriodSelector, {
                        modelValue: periodSelection.value,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((periodSelection).value = $event)),
                          updatePeriodSelection
                        ],
                        showTitle: ""
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((displayTypeSelection).value = $event)),
                            updateTypeSelection
                          ]
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedEoPVerificationsList.value, (reportType) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: reportType.EoPType
                            }, _toDisplayString(reportType.EoPName), 9, _hoisted_43))
                          }), 256))
                        ], 512), [
                          [_vModelSelect, displayTypeSelection.value]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (CreateNewReport())),
                      disabled: buttonStatus.value || gettingEoPVerificationReportError.value || _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CreateEoPVReport),
                      title: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CreateEoPVReport) ? 'Create New Report (Access Denied)' : 'Create New Report',
                      class: "new-report-button"
                    }, " Create New Report ", 8, _hoisted_45),
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (showMultiplePeriodReportPopUp.value = !showMultiplePeriodReportPopUp.value)),
                      disabled: buttonStatus.value || gettingEoPVerificationReportError.value || _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CreateEoPVReport),
                      title: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CreateEoPVReport) ? 'Create New Report (Access Denied)' : 'Create New Report',
                      class: "new-report-button"
                    }, " Create New Multiple Period Report ", 8, _hoisted_46)
                  ])
                ])
              ])),
          (!showNewFormatReport.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _hoisted_48,
                _createVNode(Table, {
                  Rows: pastEoPVerificationReports.value,
                  Cols: _unref(cols),
                  Labels: _unref(labels),
                  DefaultSortCols: _unref(defaultSortCols),
                  DefaultSortOrders: _unref(defaultSortOrders),
                  Page: page.value,
                  "onUpdate:Page": _cache[7] || (_cache[7] = ($event: any) => ((page).value = $event)),
                  HasError: infoError.value
                }, {
                  ProcessedDateTime: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(props.value.ProcessedDateTime), 1)
                  ]),
                  TotalAmount: _withCtx((props) => [
                    _createElementVNode("div", null, _toDisplayString(formatAmount(props.value.TotalAmount)), 1)
                  ]),
                  DeviationAmount: _withCtx((props) => [
                    _createElementVNode("div", null, _toDisplayString(formatAmount(props.value.DeviationAmount)), 1)
                  ]),
                  ReportName: _withCtx((props) => [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (viewFullPagePDFReport(props.value.ReportName ?? undefined,'EndOfPeriodVerification')),
                      disabled: detailedReportPdfButtonStatuses.value[props.value.ReportName ?? ''],
                      title: detailedReportPdfButtonStatuses.value[props.value.ReportName ?? ''] ? 
                                    '' : 
                                    'View report pdf (opens file in new tab)'
                            ,
                      class: "fake-link"
                    }, _toDisplayString(props.value.ReportName), 9, _hoisted_49)
                  ]),
                  _: 1
                }, 8, ["Rows", "Cols", "Labels", "DefaultSortCols", "DefaultSortOrders", "Page", "HasError"])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(MultiplePeriodEoPVerificationReportPopUp, {
      modelValue: showMultiplePeriodReportPopUp.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showMultiplePeriodReportPopUp).value = $event)),
      period: period.value,
      onConfirm: CreateNewMultiplePeriodReport
    }, null, 8, ["modelValue", "period"])
  ]))
}
}

})